import request from '@/utils/request'
import api from '../api'

export class Purchase {
  createOrder(data) {
    return request({
      url: api.purchase.createOrder,
      method: 'post',
      data
    })
  }
  payOrder(data) {
    return request({
      url: api.purchase.payOrder,
      method: 'put',
      data
    })
  }
  querySumAmount(data) {
    return request({
      url: api.purchase.querySumAmount,
      method: 'post',
      data
    })
  }
  orderDetailsDownload(params) {
    return request({
      url: api.purchase.orderDetailsDownload,
      method: 'get',
      params
    })
  }
  getOrderTemplateUrl(data) {
    return request({
      url: api.purchase.getOrderTemplateUrl,
      method: 'post',
      data
    })
  }
  progressQuery(params) {
    return request({
      url: api.purchase.progressQuery,
      method: 'get',
      params
    })
  }
  transactionList(data) {
    return request({
      url: api.purchase.transactionList,
      method: 'post',
      data
    })
  }
  transactionDownload(data) {
    return request({
      url: api.purchase.transactionDownload,
      method: 'post',
      data
    })
  }
  getOverseasTemplateUrl(params) {
    return request({
      url: api.purchase.getOverseasTemplateUrl,
      method: 'get',
      params
    })
  }
  checkInfo(params) {
    return request({
      url: api.purchase.checkInfo,
      method: 'get',
      params
    })
  }
  uploadPayeeMaterial(data) {
    return request({
      url: api.purchase.uploadPayeeMaterial,
      method: 'post',
      data
    })
  }
  uploadOrderDetail(data) {
    return request({
      url: api.purchase.uploadOrderDetail,
      method: 'post',
      data
    })
  }
  uploadMaterial(data) {
    return request({
      url: api.purchase.uploadMaterial,
      method: 'post',
      data
    })
  }
  orderList(data) {
    return request({
      url: api.purchase.orderList,
      method: 'post',
      data
    })
  }
  detail(data) {
    return request({
      url: api.purchase.detail,
      method: 'post',
      data
    })
  }
  revoke(params) {
    return request({
      url: api.purchase.revoke,
      method: 'put',
      params
    })
  }
  electReceiptDownload(data) {
    return request({
      url: api.purchase.electReceiptDownload,
      method: 'post',
      data
    })
  }
  queryCountry(params) {
    return request({
      url: api.purchase.queryCountry,
      method: 'get',
      params
    })
  }
  queryCurrency(params) {
    return request({
      url: api.purchase.queryCurrency,
      method: 'get',
      params
    })
  }
  retrieveExpries(data) {
    return request({
      url: api.purchase.retrieveExpries,
      method: 'post',
      data
    })
  }
  parsePayeeInfoFile(params) {
    return request({
      url: api.purchase.parsePayeeInfoFile,
      method: 'get',
      params
    })
  }
  fileUpload(data) {
    return request({
      url: api.purchase.fileUpload,
      method: 'post',
      data
    })
  }
}